module.exports = require("read-excel-file/node");